import { VabsPaymentSystem, requestsClient } from '@/shared/api';

import { ICreateInnerPayload, ICreatePaymentPayload } from '../config';

export const createPaymentMutation = async (
  payload: ICreatePaymentPayload | ICreateInnerPayload,
) => {
  if (payload.paymentSystem === VabsPaymentSystem.Bsb) {
    const { vabsCreateMyBsbPayment } =
      await requestsClient.vabsCreateMyBsbPayment({ input: payload.input });
    return vabsCreateMyBsbPayment;
  }

  if (payload.paymentSystem === VabsPaymentSystem.Ifsc) {
    const { vabsCreateMyIfscPayment } =
      await requestsClient.vabsCreateMyIfscPayment({ input: payload.input });
    return vabsCreateMyIfscPayment;
  }

  if (payload.paymentSystem === VabsPaymentSystem.Swift) {
    const { vabsCreateMySwiftPayment } =
      await requestsClient.vabsCreateMySwiftPayment({ input: payload.input });
    return vabsCreateMySwiftPayment;
  }

  if (payload.paymentSystem === VabsPaymentSystem.Inner) {
    const { vabsCreateMyInnerPayment } =
      await requestsClient.vabsCreateMyInnerPayment({ input: payload.input });
    return vabsCreateMyInnerPayment;
  }
};

export const calcFeeMutation = async (
  payload: ICreatePaymentPayload | ICreateInnerPayload,
) => {
  switch (payload.paymentSystem) {
    case VabsPaymentSystem.Bsb:
      return (
        await requestsClient.vabsCalculateMyBsbPaymentFee({
          input: payload.input,
        })
      ).vabsCalculateMyBsbPaymentFee;
    case VabsPaymentSystem.Ifsc:
      return (
        await requestsClient.vabsCalculateMyIfscPaymentFee({
          input: payload.input,
        })
      ).vabsCalculateMyIfscPaymentFee;
    case VabsPaymentSystem.Swift:
      return (
        await requestsClient.vabsCalculateMySwiftPaymentFee({
          input: payload.input,
        })
      ).vabsCalculateMySwiftPaymentFee;
    case VabsPaymentSystem.Inner:
      return (
        await requestsClient.vabsCalculateMyInnerPaymentFee({
          input: payload.input,
        })
      ).vabsCalculateMyInnerPaymentFee;
    default:
      return null;
  }
};
